$(document).on('ready turbolinks:load', () => {
  const $dropdowns = $('.dropdown');

  $dropdowns.each((index, dropdown) => {
    const $dropdown = $(dropdown);
    const $dropdownButton = $dropdown.children('.dropdown__button');
    const $dropdownMenu = $dropdown.children('.dropdown__menu');
    const activeClass = 'dropdown--active';

    $dropdownButton.on('click', function (event) {
      const isActive = $dropdown.hasClass(activeClass);

      const onClose = ({ target }) => {
        const isMenuClick = $dropdown.find(target).length > 0;
        const isButtonClick = target === this || $(this).find(target).length > 0;

        if (!isMenuClick || (isActive && isButtonClick)) {
          $dropdown.removeClass(activeClass);
          $dropdownButton.blur();
        }
      };

      if (isActive) {
        $(window).off('click', onClose);
        onClose(event);
        return;
      }

      $(window).on('click', onClose);
      $dropdown.addClass(activeClass);
    })
  })
});
